import { render, staticRenderFns } from "./zayavka-na-vozvratobmen-bileta.vue?vue&type=template&id=388e874d"
import script from "./zayavka-na-vozvratobmen-bileta.vue?vue&type=script&lang=js"
export * from "./zayavka-na-vozvratobmen-bileta.vue?vue&type=script&lang=js"
import style0 from "./zayavka-na-vozvratobmen-bileta.vue?vue&type=style&index=0&id=388e874d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzButton: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/button/index.js').default})
